import React from "react";
import ReactApexChart from "react-apexcharts";

const LineChart = () => {
  const series = [
    {
      name: "Current Week",
      data: [50, 100, 200, 170, 250, 275, 280],
    },
  ];
  var options: any = {
    chart: {
      height: 300,
      type: "area",
      fontFamily: "Inter, sans-serif",
      zoom: {
        enabled: false,
      },
      toolbar: {
        show: false,
      },
    },
    dataLabels: {
      enabled: false,
    },
    stroke: {
      show: true,
      curve: "smooth",
      width: 3,
      lineCap: "square",
    },
    dropShadow: {
      enabled: true,
      opacity: 0.8,
      blur: 10,
      left: -7,
      top: 22,
    },
    colors: ["#6a69f5"],
    markers: {
      discrete: [
        {
          seriesIndex: 0,
          dataPointIndex: 4,
          fillColor: "#323a46",
          strokeColor: "#fff",
          size: 6,
        },
        {
          seriesIndex: 1,
          dataPointIndex: 5,
          fillColor: "#A8C5DA",
          strokeColor: "#fff",
          size: 6,
        },
      ],
    },
    labels: ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"],
    xaxis: {
      axisBorder: {
        show: false,
      },
      axisTicks: {
        show: false,
      },
      crosshairs: {
        show: true,
      },
      labels: {
        offsetX: 0,
        offsetY: 5,
        style: {
          fontSize: "12px",
          cssClass: "apexcharts-xaxis-title",
        },
      },
    },
    yaxis: {
      tickAmount: 5,
      labels: {
        offsetX: -10,
        offsetY: 0,
        style: {
          fontSize: "12px",
          cssClass: "apexcharts-yaxis-title",
        },
      },
      opposite: false,
    },
    grid: {
      borderColor: "#e8e8e8",
      strokeDashArray: 7,
      xaxis: {
        lines: {
          show: false,
        },
      },
      yaxis: {
        lines: {
          show: true,
        },
      },
      padding: {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
      },
    },
    legend: {
      show: false,
    },
    tooltip: {
      marker: {
        show: true,
      },
      x: {
        show: false,
      },
    },
    fill: {
      type: "gradient",
      gradient: {
        shadeIntensity: 1,
        inverseColors: !1,
        opacityFrom: 0,
        opacityTo: 0,
        stops: [100, 100],
      },
    },
  };
  return (
    <React.Fragment>
      <ReactApexChart
        type="area"
        series={series}
        options={options}
        id="linechart"
        dir="ltr"
        height={300}
      />
    </React.Fragment>
  );
};

const AreaChart = () => {
  const series = [
    {
      name: "Income",
      data: [
        1680, 1680, 1550, 1780, 1550, 1700, 1900, 1600, 1500, 1700, 1400, 1700,
      ],
    },
  ];
  var option: any = {
    chart: {
      type: "area",
      height: 300,
      zoom: {
        enabled: false,
      },
      toolbar: {
        show: false,
      },
    },
    colors: ["#94989a"],
    dataLabels: {
      enabled: false,
    },
    stroke: {
      width: 2,
      curve: "smooth",
    },
    xaxis: {
      axisBorder: {
        color: "#e0e6ed",
      },
    },
    yaxis: {
      opposite: false,
      labels: {
        offsetX: 0,
      },
    },
    labels: [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ],
    legend: {
      horizontalAlign: "left",
    },
    grid: {
      borderColor: "#e8e8e8",
    },
  };

  return (
    <React.Fragment>
      <ReactApexChart
        type="area"
        series={series}
        options={option}
        id="areachart"
        dir="ltr"
        height={300}
      />
    </React.Fragment>
  );
};

const BarChart = () => {

    const  series= [
        {
            name: "PRODUCT A",
            data: [44, 55, 41, 67, 22, 43],
        },
        {
            name: "PRODUCT B",
            data: [13, 23, 20, 8, 13, 27],
        },
        {
            name: "PRODUCT C",
            data: [11, 17, 15, 15, 21, 14],
        },
    ];
    var option : any = {
        chart: {
            type: "bar",
            height: 300,
            stacked: true,
            toolbar: {
                show: false,
            },
            zoom: {
                enabled: false,
            },
        },
        dataLabels: {
            enabled: false,
        },
        colors: ["#323a46", "#50cd89", "#6a69f5"],
    
        plotOptions: {
            bar: {
                horizontal: false,
                borderRadius: 10,
                columnWidth: "25%",
            },
        },
        xaxis: {
            categories: ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
        },
        legend: {
            show: false,
        },
        fill: {
            opacity: 1,
        },
    }

    return (
        <React.Fragment>
          <ReactApexChart
            type="bar"
            series={series}
            options={option}
            id="barchart"
            dir="ltr"
            height={300}
          />
        </React.Fragment>
      );
};

const SimpleBarChart = () => {

    const series = [
        {
            name: "Sales",
            data: [2500, 1500, 2000, 3000, 4000, 4500],
        },
    ];
    var options : any = {
        chart: {
            height: 300,
            type: "bar",
            zoom: {
                enabled: false,
            },
            toolbar: {
                show: false,
            },
        },
        dataLabels: {
            enabled: false,
        },
        stroke: {
            show: true,
            width: 1,
        },
        colors: ["#6a69f5"],
        xaxis: {
            categories: ["Q1", "Q2", "Q3", "Q4", "Q5"],
            axisBorder: {
                color: "#e0e6ed",
            },
        },
        yaxis: {
            opposite: false,
            reversed: false,
        },
        grid: {
            borderColor: "#e8e8e8",
        },
        plotOptions: {
            bar: {
                horizontal: true,
            },
        },
        fill: {
            opacity: 0.8,
        }
    }
    return (
        <React.Fragment>
          <ReactApexChart
            type="bar"
            series={series}
            options={options}
            id="simplebarchart"
            dir="ltr"
            height={300}
          />
        </React.Fragment>
      );
}

export { LineChart, AreaChart, BarChart, SimpleBarChart };
